import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EvolucaoGetModel, EvolucaoListModel, EvolucaoPostModel } from "app/models/evolucao.model";
import { RespostaPadrao } from "app/models/resposta-padrao.model";
import { environment } from "environments/environment";
import { Observable, firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class EvolucaoService {
    constructor(private httpClient: HttpClient) { }

    adicionar(evolucao: EvolucaoPostModel): Observable<RespostaPadrao> {
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Evolucao/adicionar`, evolucao);
    }

    atualizar(evolucao: EvolucaoPostModel): Observable<RespostaPadrao> {
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Evolucao/atualizar`, evolucao);
    }

    async obterPorId(evolucaoId: number): Promise<EvolucaoGetModel> {
        return firstValueFrom(
            this.httpClient.get<EvolucaoGetModel>(`${environment.urlApi}/Evolucao/obter/${evolucaoId}`)
        );
    }

    async obterPorCliente(clienteId: number): Promise<EvolucaoListModel[]> {
        return firstValueFrom(
            this.httpClient.get<EvolucaoListModel[]>(`${environment.urlApi}/Evolucao/obterPorCliente/${clienteId}`)
        );
    }

    async obterPorGrupo(grupoId: number): Promise<EvolucaoListModel[]> {
        return firstValueFrom(
            this.httpClient.get<EvolucaoListModel[]>(`${environment.urlApi}/Evolucao/obterPorGrupo/${grupoId}`)
        );
    }

    remover(evolucaoId: number): Observable<RespostaPadrao> {
        return this.httpClient.delete<RespostaPadrao>(`${environment.urlApi}/Evolucao/remover/${evolucaoId}`);
    }
}
